import { render, staticRenderFns } from "./Lgx279918223527247872.vue?vue&type=template&id=3fdb3b50&"
import script from "./Lgx279918223527247872.vue?vue&type=script&lang=js&"
export * from "./Lgx279918223527247872.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports